import React, { useEffect } from "react";

import "./portal.scss";

// Declaración global para PureCounter en window
declare global {
  interface Window {
    PureCounter?: any;
  }
}

export const PortalHome2: React.FC = () => {
  const [tabIndex, setTabIndex] = React.useState<string>("home");

  // Datos de ejemplo de profesionales
  const profesionalesData = [
    {
      nombre: "Walter White",
      consultorio: "Av. Spinetto 670, Santa Rosa",
      localidad: "Santa Rosa",
      telefono: "2954-123456",
      matricula: "1234",
      cuit: "20-12345678-9",
      especialidades: ["Fonoaudiología", "Audiología"],
      atiendeObraSocial: true,
      redes: {
        twitter: "https://twitter.com",
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        linkedin: "https://linkedin.com",
      },
    },
    {
      nombre: "Sarah Jhonson",
      consultorio: "Belgrano 123, General Pico",
      localidad: "General Pico",
      telefono: "2954-654321",
      matricula: "5678",
      cuit: "27-87654321-0",
      especialidades: ["Voz", "Lenguaje"],
      atiendeObraSocial: false,
      redes: {
        // twitter: 'https://twitter.com',
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        // linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: "William Anderson",
      consultorio: "Rivadavia 456, Santa Rosa",
      localidad: "Santa Rosa",
      telefono: "2954-789012",
      matricula: "9101",
      cuit: "23-11223344-5",
      especialidades: ["Odontoesmatología", "Deglución"],
      atiendeObraSocial: true,
      redes: {
        twitter: "https://twitter.com",
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        linkedin: "https://linkedin.com",
      },
    },
    {
      nombre: "Amanda Jepson",
      consultorio: "San Martín 789, Toay",
      localidad: "Toay",
      telefono: "2954-345678",
      matricula: "1121",
      cuit: "27-55667788-1",
      especialidades: ["Rehabilitación", "Audiología"],
      atiendeObraSocial: true,
      redes: {
        twitter: "https://twitter.com",
        facebook: "https://facebook.com",
        instagram: "https://instagram.com",
        linkedin: "https://linkedin.com",
      },
    },
    // Nuevos profesionales de ejemplo
    {
      nombre: "Lucía Fernández",
      consultorio: "Av. Luro 1500, Santa Rosa",
      localidad: "Santa Rosa",
      telefono: "2954-111222",
      matricula: "2233",
      cuit: "27-33445566-2",
      especialidades: ["Lenguaje", "Fonoaudiología"],
      atiendeObraSocial: true,
      redes: {
        twitter: "",
        facebook: "https://facebook.com/luciaf",
        instagram: "https://instagram.com/luciaf",
        linkedin: "",
      },
    },
    {
      nombre: "Martín Gómez",
      consultorio: "Calle 9 N° 456, General Pico",
      localidad: "General Pico",
      telefono: "2954-333444",
      matricula: "3344",
      cuit: "20-99887766-3",
      especialidades: ["Audiología"],
      atiendeObraSocial: false,
      redes: {
        twitter: "https://twitter.com/mgomez",
        facebook: "",
        instagram: "",
        linkedin: "https://linkedin.com/in/mgomez",
      },
    },
    {
      nombre: "Paula Sosa",
      consultorio: "Av. Perón 234, Toay",
      localidad: "Toay",
      telefono: "2954-555666",
      matricula: "4455",
      cuit: "23-44556677-8",
      especialidades: ["Voz", "Rehabilitación"],
      atiendeObraSocial: true,
      redes: {
        twitter: "",
        facebook: "",
        instagram: "https://instagram.com/paulasosa",
        linkedin: "",
      },
    },
    {
      nombre: "Federico Ruiz",
      consultorio: "Mitre 800, Santa Rosa",
      localidad: "Santa Rosa",
      telefono: "2954-777888",
      matricula: "5566",
      cuit: "20-22334455-6",
      especialidades: ["Odontoesmatología", "Lenguaje", "Deglución"],
      atiendeObraSocial: false,
      redes: {
        twitter: "https://twitter.com/federicoruiz",
        facebook: "",
        instagram: "",
        linkedin: "",
      },
    },
    {
      nombre: "María López",
      consultorio: "Calle 25 N° 100, General Pico",
      localidad: "General Pico",
      telefono: "2954-999000",
      matricula: "6677",
      cuit: "27-77889900-1",
      especialidades: ["Fonoaudiología"],
      atiendeObraSocial: true,
      redes: {
        twitter: "",
        facebook: "https://facebook.com/marialopez",
        instagram: "",
        linkedin: "",
      },
    },
  ];

  // Estado de filtros
  const [filtroNombre, setFiltroNombre] = React.useState("");
  const [filtroLocalidad, setFiltroLocalidad] = React.useState("");
  const [filtroObraSocial, setFiltroObraSocial] = React.useState("");
  const [filtroEspecialidad, setFiltroEspecialidad] = React.useState("");

  // Obtener opciones únicas de localidad y especialidad
  const localidades = Array.from(
    new Set(profesionalesData.map((p) => p.localidad))
  );
  const especialidades = Array.from(
    new Set(profesionalesData.flatMap((p) => p.especialidades))
  );

  // Filtrado de profesionales
  const profesionalesFiltrados = profesionalesData.filter((p) => {
    const matchNombre =
      p.nombre.toLowerCase().includes(filtroNombre.toLowerCase()) ||
      p.matricula.toLowerCase().includes(filtroNombre.toLowerCase());
    const matchLocalidad = !filtroLocalidad || p.localidad === filtroLocalidad;
    const matchObraSocial =
      !filtroObraSocial ||
      (filtroObraSocial === "si" && p.atiendeObraSocial) ||
      (filtroObraSocial === "no" && !p.atiendeObraSocial);
    const matchEspecialidad =
      !filtroEspecialidad || p.especialidades.includes(filtroEspecialidad);
    return (
      matchNombre && matchLocalidad && matchObraSocial && matchEspecialidad
    );
  });

  useEffect(() => {
    if (tabIndex === "institucional" && window.PureCounter) {
      new window.PureCounter();
    }
  }, [tabIndex]);

  useEffect(() => {
    // Cargar scripts JS solo cuando el portal está montado
    const scripts = [
      "./assets/portal/vendor/bootstrap/js/bootstrap.bundle.min.js",
      "./assets/portal/vendor/php-email-form/validate.js",
      "./assets/portal/vendor/aos/aos.js",
      "./assets/portal/vendor/glightbox/js/glightbox.min.js",
      "./assets/portal/vendor/purecounter/purecounter_vanilla.js",
      "./assets/portal/js/main.js",
    ];
    const scriptElements = scripts.map((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    });
    // Cargar fuentes solo para el portal
    const fontLinks = [
      { href: "https://fonts.googleapis.com", rel: "preconnect" },
      {
        href: "https://fonts.gstatic.com",
        rel: "preconnect",
        crossorigin: "anonymous",
      },
      {
        href: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
        rel: "stylesheet",
      },
    ];
    const linkElements = fontLinks.map((props) => {
      const link = document.createElement("link");
      Object.entries(props).forEach(([key, value]) =>
        link.setAttribute(key, value)
      );
      document.head.appendChild(link);
      return link;
    });
    // Cargar estilos CSS solo para el portal
    const cssLinks = [
      "/assets/portal/vendor/bootstrap/css/bootstrap.min.css",
      "/assets/portal/vendor/bootstrap-icons/bootstrap-icons.css",
      "/assets/portal/vendor/aos/aos.css",
      "/assets/portal/vendor/fontawesome-free/css/all.min.css",
      "/assets/portal/vendor/glightbox/css/glightbox.min.css",
      "/assets/portal/vendor/swiper/swiper-bundle.min.css",
      "/assets/portal/css/main.css",
    ];
    const cssElements = cssLinks.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });
    return () => {
      scriptElements.forEach((script) => {
        if (document.body.contains(script)) document.body.removeChild(script);
      });
      linkElements.forEach((link) => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
      cssElements.forEach((link) => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
    };
  }, []);

  return (
    <>
      {/* HEADER - ESTILO TENUE */}
      <header id="header" className="header sticky-top">
        <div
          className="topbar d-flex align-items-center"
          style={{
            background:
              "linear-gradient(135deg, rgba(156, 163, 175, 0.85) 0%, rgba(209, 213, 219, 0.85) 50%, rgba(229, 231, 235, 0.85) 100%)",
            backdropFilter: "blur(15px)",
            borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
            boxShadow: "0 2px 15px rgba(0, 0, 0, 0.05)",
            padding: "12px 0",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Elemento decorativo de fondo suave */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: `
              radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 50%, rgba(156, 163, 175, 0.1) 0%, transparent 50%)
            `,
              zIndex: 1,
            }}
          />

          <div
            className="container d-flex justify-content-center justify-content-md-between"
            style={{
              position: "relative",
              zIndex: 2,
            }}
          >
            <div
              className="d-none d-md-flex align-items-center"
              style={{
                color: "#4b5563",
                fontSize: "0.9rem",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
                textShadow: "0 1px 2px rgba(255, 255, 255, 0.8)",
                letterSpacing: "0.2px",
              }}
            >
              <i
                className="bi bi-building me-2"
                style={{
                  fontSize: "1rem",
                  color: "#d4a574",
                }}
              ></i>
              Colegio Profesional de Fonoaudiólogos de La Pampa
            </div>
            <a
              href="https://wa.me/5429542954702284?text=Hola,%20necesito%20información%20sobre%20los%20servicios%20del%20Colegio%20de%20Fonoaudiólogos"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center"
              style={{
                color: "#374151",
                fontSize: "0.9rem",
                fontWeight: "500",
                fontFamily: "'Inter', sans-serif",
                textShadow: "0 1px 2px rgba(255, 255, 255, 0.5)",
                letterSpacing: "0.2px",
                textDecoration: "none",
                transition: "all 0.3s ease",
                padding: "8px 15px",
                borderRadius: "20px",
                backgroundColor: "rgba(255, 255, 255, 0.6)",
                backdropFilter: "blur(8px)",
                border: "1px solid rgba(156, 163, 175, 0.3)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(34, 197, 94, 0.1)";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(34, 197, 94, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.6)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <i
                className="bi bi-whatsapp me-2"
                style={{
                  fontSize: "1rem",
                  color: "#22c55e",
                  animation: "softPulse 3s infinite",
                }}
              ></i>
              Contáctanos por WhatsApp
            </a>
          </div>
        </div>
        <div className="branding d-flex align-items-center">
          <div className="container position-relative d-flex align-items-center justify-content-end">
            <a
              href="index.html"
              className="logo d-flex align-items-center me-auto"
            >
              <img src="assets/img/logo-cofolp.png" alt="" />
            </a>
            <nav id="navmenu" className="navmenu">
              <ul>
                <li>
                  <a
                    href="#"
                    className="active"
                    onClick={() => setTabIndex("home")}
                  >
                    Inicio
                  </a>
                </li>
                <li className="dropdown">
                  <a href="#" onClick={() => setTabIndex("institucional")}>
                    <span>Institucional</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="#" onClick={() => setTabIndex("institucional")}>
                        Quiénes somos?
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("institucional")}>
                        Comisión Directiva
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("institucional")}>
                        Tribunal de Etica y Disciplina
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("institucional")}>
                        Comisión Revisora de Cuentas
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <a href="#" onClick={() => setTabIndex("tramites")}>
                    <span>Trámites</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="#" onClick={() => setTabIndex("matriculacion")}>
                        Matriculación
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("consultorio")}>
                        Consultorio
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("tramites")}>
                        Título
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => setTabIndex("tramites")}>
                        Baja de Matrícula
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Habilitación de Consultorio
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <a
                    href="#"
                    onClick={() => setTabIndex("ejercicio-profesional")}
                  >
                    <span>Ejercicio Profesional</span>{" "}
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Honorarios Mínimos
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Código de ética
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("certificado-etica")}
                      >
                        Certificado de ética
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Consentimiento informado
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => setTabIndex("ejercicio-profesional")}
                      >
                        Habilitación de Consultorio
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#" onClick={() => setTabIndex("profesionales")}>
                    Profesionales
                  </a>
                </li>
                <li>
                  <a href="#">Obras Sociales</a>
                </li>
                <li>
                  <a href="#" onClick={() => setTabIndex("contacto")}>
                    Contacto
                  </a>
                </li>
              </ul>
              <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
            </nav>
            <a
              className="cta-btn"
              href="http://145.223.94.120/"
              target="_blank"
              rel="noopener noreferrer"
            >
              AUTOGESTION
            </a>
          </div>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main className="main">
        {tabIndex === "home" && (
          <>
            <section
              id="hero"
              className="hero section"
              style={{
                position: "relative",
                height: "auto",
                minHeight: "320px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#8b8b8b",
                overflow: "hidden",
                padding: "20px 0",
              }}
            >
              {/* Contenido principal */}
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  position: "relative",
                  zIndex: 4,
                  // padding: '60px 0'
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "55%",
                    height: "auto",
                    position: "relative",
                    overflow: "visible",
                  }}
                >
                  <video
                    autoPlay
                    muted
                    loop={false}
                    playsInline
                    style={{
                      width: "1600px",
                      height: "auto",
                      objectFit: "contain",
                      opacity: 0,
                      transform: "translateY(20px)",
                      animation: "scaleIn 1s ease-out 0.3s forwards",
                    }}
                    onLoadedData={(e) => {
                      // Asegurar que el video se reproduzca
                      e.currentTarget.play().catch(() => {
                        // Si autoplay falla, al menos mostrar el primer frame
                        e.currentTarget.currentTime = 0;
                      });
                    }}
                  >
                    <source
                      src="./assets/portal/img/logo_banner.webm"
                      type="video/webm"
                    />
                    {/* Fallback para navegadores que no soporten webm */}
                    <img
                      src="./assets/img/logo-cofolp.png"
                      alt="Logo COFOLP"
                      style={{
                        width: "auto",
                        height: "auto",
                        maxWidth: "100%",
                        maxHeight: "280px",
                        objectFit: "contain",
                      }}
                    />
                  </video>
                </div>
                <div
                  className="banner-text"
                  style={{
                    width: "45%",
                    height: "auto",
                    maxWidth: "600px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "40px 30px",
                    margin: "20px",
                    textAlign: "center",
                    background:
                      "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(249, 250, 251, 0.8) 100%)",
                    backdropFilter: "blur(20px)",
                    borderRadius: "25px",
                    border: "2px solid rgba(229, 231, 235, 0.5)",
                    boxShadow:
                      "0 20px 40px rgba(107, 114, 128, 0.1), 0 8px 25px rgba(156, 163, 175, 0.1)",
                    position: "relative",
                    overflow: "hidden",
                    opacity: 0,
                    transform: "translateY(30px)",
                    animation: "softSlideUp 1.8s ease-out 0.9s forwards",
                  }}
                >
                  {/* Elemento decorativo suave */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-40%",
                      right: "-25%",
                      width: "150px",
                      height: "150px",
                      background:
                        "linear-gradient(45deg, rgba(229, 231, 235, 0.3), transparent)",
                      borderRadius: "50%",
                      zIndex: 1,
                    }}
                  />

                  {/* Contenido del texto */}
                  <div style={{ position: "relative", zIndex: 2 }}>
                    <h2
                      style={{
                        color: "#374151",
                        fontSize: "2.2rem",
                        fontWeight: "600",
                        lineHeight: "1.3",
                        textShadow: "0 2px 4px rgba(107, 114, 128, 0.1)",
                        margin: 0,
                        fontFamily: "'Inter', sans-serif",
                        letterSpacing: "-0.3px",
                        marginBottom: "15px",
                      }}
                    >
                      El respaldo de la
                      <br />
                      <span
                        style={{
                          color: "#d4a574",
                          fontWeight: "700",
                          fontSize: "2.4rem",
                        }}
                      >
                        Fonoaudiología
                      </span>
                      <br />
                      en La Pampa
                    </h2>

                    <div
                      style={{
                        width: "50px",
                        height: "2px",
                        background: "linear-gradient(90deg, #d4a574, #e2c89c)",
                        margin: "20px auto",
                        borderRadius: "1px",
                      }}
                    />

                    <p
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "400",
                        color: "#6b7280",
                        margin: 0,
                        fontFamily: "'Inter', sans-serif",
                        letterSpacing: "0.1px",
                        textShadow: "0 1px 2px rgba(255, 255, 255, 0.8)",
                      }}
                    >
                      Regulación • Formación • Ética
                    </p>
                  </div>
                </div>
              </div>

              <style>{`
                /* Animaciones suaves para PortalHome2 */
                @keyframes scaleIn {
                  0% {
                    opacity: 0;
                    transform: scale(0.8);
                  }
                  100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                }
                @keyframes softFadeIn {
                  0% {
                    opacity: 0;
                    transform: translateY(15px) scale(0.98);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                  }
                }
                
                @keyframes logoAppear {
                  0% {
                    opacity: 0;
                    transform: translateY(-20px) scale(0.9);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                  }
                }
                
                @keyframes softSlideUp {
                  0% {
                    opacity: 0;
                    transform: translateY(25px) scale(0.97);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                  }
                }
                
                @keyframes softGradientShift {
                  0% {
                    background-position: 0% 50%;
                  }
                  50% {
                    background-position: 100% 50%;
                  }
                  100% {
                    background-position: 0% 50%;
                  }
                }
                
                @keyframes softPulse {
                  0%, 100% {
                    opacity: 0.8;
                    transform: scale(1);
                  }
                  50% {
                    opacity: 1;
                    transform: scale(1.02);
                  }
                }
                
                @keyframes softPatternFloat {
                  0% {
                    transform: translateX(0) translateY(0);
                  }
                  50% {
                    transform: translateX(-5px) translateY(-10px);
                  }
                  100% {
                    transform: translateX(0) translateY(0);
                  }
                }
                
                @keyframes gentleFloat {
                  0%, 100% {
                    transform: translateY(0px) scale(1);
                  }
                  50% {
                    transform: translateY(-10px) scale(1.01);
                  }
                }
                
                /* Responsive para PortalHome2 */
                @media (max-width: 768px) {
                  .topbar {
                    padding: 10px 0 !important;
                  }
                  
                  #hero {
                    min-height: 420px !important;
                  }
                  
                  .banner-text {
                    display: none !important;
                  }
                  
                  #hero > div:last-child {
                    justify-content: center !important;
                  }
                  
                  #hero > div:last-child > div:first-child {
                    width: 100% !important;
                    flex-direction: column !important;
                  }
                  
                  .animated-logo {
                    height: 250px !important;
                    width: auto !important;
                    max-width: 90vw !important;
                  }
                }
                
                @media (max-width: 480px) {
                  #hero {
                    min-height: 350px !important;
                  }
                  
                  .animated-logo {
                    height: 200px !important;
                    width: auto !important;
                    max-width: 95vw !important;
                  }
                }
              `}</style>
            </section>

            {/* Featured Services Section - ESTILO TENUE */}
            <section
              id="featured-services"
              className="featured-services section"
              style={{
                background: "linear-gradient(135deg, #fefefe 0%, #f9fafb 100%)",
                padding: "50px 0",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Elementos decorativos suaves */}
              <div
                style={{
                  position: "absolute",
                  top: "-80px",
                  right: "-80px",
                  width: "300px",
                  height: "300px",
                  background:
                    "linear-gradient(135deg, rgba(243, 244, 246, 0.6), rgba(229, 231, 235, 0.4))",
                  borderRadius: "50%",
                  zIndex: 1,
                }}
              />

              <div
                className="container"
                style={{ position: "relative", zIndex: 2 }}
              >
                <div className="row gy-4 justify-content-center">
                  {/* Servicio 1: Acceso a AUTOGESTION - Tonos suaves */}
                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div
                      className="soft-service-card"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(243, 244, 246, 0.8) 0%, rgba(249, 250, 251, 0.9) 100%)",
                        backdropFilter: "blur(15px)",
                        borderRadius: "20px",
                        padding: "35px 25px",
                        textAlign: "center",
                        border: "2px solid rgba(229, 231, 235, 0.6)",
                        boxShadow: "0 15px 35px rgba(107, 114, 128, 0.08)",
                        transition: "all 0.4s ease",
                        cursor: "pointer",
                        position: "relative",
                        overflow: "hidden",
                        height: "100%",
                        minHeight: "300px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(-5px) scale(1.01)";
                        e.currentTarget.style.boxShadow =
                          "0 25px 50px rgba(107, 114, 128, 0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 15px 35px rgba(107, 114, 128, 0.08)";
                      }}
                      onClick={() =>
                        window.open("http://145.223.94.120/", "_blank")
                      }
                    >
                      <div style={{ position: "relative", zIndex: 2 }}>
                        <div
                          className="soft-service-icon"
                          style={{
                            width: "70px",
                            height: "70px",
                            background:
                              "linear-gradient(135deg, #9ca3af, #6b7280)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            boxShadow: "0 8px 25px rgba(107, 114, 128, 0.2)",
                          }}
                        >
                          <i
                            className="fas fa-laptop-code"
                            style={{
                              fontSize: "1.8rem",
                              color: "white",
                            }}
                          ></i>
                        </div>

                        <h4
                          style={{
                            fontSize: "1.3rem",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "15px",
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Acceso a AUTOGESTION
                        </h4>

                        <p
                          style={{
                            color: "#6b7280",
                            fontSize: "0.95rem",
                            lineHeight: "1.5",
                            margin: 0,
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Gestione sus trámites, consulte su estado de cuenta y
                          acceda a servicios digitales.
                        </p>

                        <div
                          style={{
                            marginTop: "18px",
                            padding: "8px 18px",
                            background:
                              "linear-gradient(90deg, #9ca3af, #6b7280)",
                            color: "white",
                            borderRadius: "20px",
                            fontSize: "0.85rem",
                            fontWeight: "400",
                            display: "inline-block",
                          }}
                        >
                          Ingresar →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 2: Buscar Fonoaudiólogo - Tonos suaves */}
                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div
                      className="soft-service-card"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(239, 246, 255, 0.8) 0%, rgba(243, 244, 246, 0.9) 100%)",
                        backdropFilter: "blur(15px)",
                        borderRadius: "20px",
                        padding: "35px 25px",
                        textAlign: "center",
                        border: "2px solid rgba(196, 181, 253, 0.3)",
                        boxShadow: "0 15px 35px rgba(107, 114, 128, 0.08)",
                        transition: "all 0.4s ease",
                        cursor: "pointer",
                        position: "relative",
                        overflow: "hidden",
                        height: "100%",
                        minHeight: "300px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(-5px) scale(1.01)";
                        e.currentTarget.style.boxShadow =
                          "0 25px 50px rgba(139, 92, 246, 0.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 15px 35px rgba(107, 114, 128, 0.08)";
                      }}
                      onClick={() => setTabIndex("profesionales")}
                    >
                      <div style={{ position: "relative", zIndex: 2 }}>
                        <div
                          className="soft-service-icon"
                          style={{
                            width: "70px",
                            height: "70px",
                            background:
                              "linear-gradient(135deg, #a5b4fc, #8b5cf6)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            boxShadow: "0 8px 25px rgba(139, 92, 246, 0.2)",
                          }}
                        >
                          <i
                            className="fas fa-user-md"
                            style={{
                              fontSize: "1.8rem",
                              color: "white",
                            }}
                          ></i>
                        </div>

                        <h4
                          style={{
                            fontSize: "1.3rem",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "15px",
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Buscar Fonoaudiólogo
                        </h4>

                        <p
                          style={{
                            color: "#6b7280",
                            fontSize: "0.95rem",
                            lineHeight: "1.5",
                            margin: 0,
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Encuentre profesionales por especialidad, localidad y
                          cobertura.
                        </p>

                        <div
                          style={{
                            marginTop: "18px",
                            padding: "8px 18px",
                            background:
                              "linear-gradient(90deg, #a5b4fc, #8b5cf6)",
                            color: "white",
                            borderRadius: "20px",
                            fontSize: "0.85rem",
                            fontWeight: "400",
                            display: "inline-block",
                          }}
                        >
                          Buscar →
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Servicio 3: Próximos Cursos y Eventos - Tonos suaves */}
                  <div
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <div
                      className="soft-service-card"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(254, 252, 232, 0.8) 0%, rgba(249, 250, 251, 0.9) 100%)",
                        backdropFilter: "blur(15px)",
                        borderRadius: "20px",
                        padding: "35px 25px",
                        textAlign: "center",
                        border: "2px solid rgba(251, 191, 36, 0.3)",
                        boxShadow: "0 15px 35px rgba(107, 114, 128, 0.08)",
                        transition: "all 0.4s ease",
                        cursor: "pointer",
                        position: "relative",
                        overflow: "hidden",
                        height: "100%",
                        minHeight: "300px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(-5px) scale(1.01)";
                        e.currentTarget.style.boxShadow =
                          "0 25px 50px rgba(251, 191, 36, 0.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 15px 35px rgba(107, 114, 128, 0.08)";
                      }}
                      onClick={() => {
                        alert(
                          "Sección de Cursos y Eventos próximamente disponible"
                        );
                      }}
                    >
                      <div style={{ position: "relative", zIndex: 2 }}>
                        <div
                          className="soft-service-icon"
                          style={{
                            width: "70px",
                            height: "70px",
                            background:
                              "linear-gradient(135deg, #fde68a, #f59e0b)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                            boxShadow: "0 8px 25px rgba(245, 158, 11, 0.2)",
                          }}
                        >
                          <i
                            className="fas fa-calendar-alt"
                            style={{
                              fontSize: "1.8rem",
                              color: "white",
                            }}
                          ></i>
                        </div>

                        <h4
                          style={{
                            fontSize: "1.3rem",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "15px",
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Próximos Cursos y Eventos
                        </h4>

                        <p
                          style={{
                            color: "#6b7280",
                            fontSize: "0.95rem",
                            lineHeight: "1.5",
                            margin: 0,
                            fontFamily: "'Inter', sans-serif",
                          }}
                        >
                          Capacitación continua y eventos de actualización
                          profesional.
                        </p>

                        <div
                          style={{
                            marginTop: "18px",
                            padding: "8px 18px",
                            background:
                              "linear-gradient(90deg, #fde68a, #f59e0b)",
                            color: "white",
                            borderRadius: "20px",
                            fontSize: "0.85rem",
                            fontWeight: "400",
                            display: "inline-block",
                          }}
                        >
                          Ver Eventos →
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {/* Resto de secciones iguales al PortalHome original... */}
        {tabIndex === "institucional" && (
          <>
            {/* Stats Section */}
            <section id="stats" className="stats section">
              <div
                className="container"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="row gy-4">
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100"></div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100"></div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100"></div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100"></div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === "profesionales" && (
          <div className="profesionales">
            {/* Modern Professionals Section */}
            <section
              id="profesionales"
              className="professionals section"
              style={{
                background: "#8b8b8b",
                position: "relative",
                overflow: "hidden",
                padding: "50px 0",
              }}
            >
              {/* Elementos de fondo suaves - igual que la sección inicio */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: `
                                radial-gradient(circle at 25% 25%, rgba(229, 231, 235, 0.4) 0%, transparent 60%),
                                radial-gradient(circle at 75% 75%, rgba(209, 213, 219, 0.3) 0%, transparent 60%),
                                radial-gradient(circle at 50% 50%, rgba(243, 244, 246, 0.2) 0%, transparent 60%)
                              `,
                  zIndex: 1,
                }}
              />

              {/* Overlay principal suave */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: `
                                linear-gradient(135deg, 
                                  rgba(249, 250, 251, 0.7) 0%, 
                                  rgba(243, 244, 246, 0.6) 25%,
                                  rgba(229, 231, 235, 0.5) 50%, 
                                  rgba(243, 244, 246, 0.6) 75%,
                                  rgba(249, 250, 251, 0.7) 100%
                                )
                              `,
                  backdropFilter: "blur(2px)",
                  zIndex: 2,
                }}
              />

              <div
                className="container"
                style={{ position: "relative", zIndex: 3 }}
              >
                {/* Título moderno */}
                <div className="row">
                  <div
                    className="col-lg-12 text-center mb-5"
                    data-aos="fade-up"
                  >
                    <h2
                      style={{
                        fontSize: "3rem",
                        fontWeight: "700",
                        color: "#374151",
                        marginBottom: "15px",
                        fontFamily: "'Inter', sans-serif",
                        textShadow: "0 2px 4px rgba(107, 114, 128, 0.1)",
                      }}
                    >
                      Nuestros{" "}
                      <span
                        style={{
                          color: "#d4a574",
                        }}
                      >
                        Profesionales
                      </span>
                    </h2>
                    <p
                      style={{
                        fontSize: "1.2rem",
                        color: "#6b7280",
                        maxWidth: "600px",
                        margin: "0 auto",
                        fontFamily: "'Inter', sans-serif",
                        textShadow: "0 1px 2px rgba(255, 255, 255, 0.8)",
                      }}
                    >
                      Encuentra a nuestros profesionales matriculados
                      especializados en fonoaudiología
                    </p>
                  </div>
                </div>

                {/* Filtros modernos con glassmorphism - estilo sección inicio */}
                <div
                  className="row mb-5"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="col-12">
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(249, 250, 251, 0.8) 100%)",
                        backdropFilter: "blur(20px)",
                        borderRadius: "25px",
                        padding: "35px 30px",
                        border: "2px solid rgba(229, 231, 235, 0.5)",
                        boxShadow:
                          "0 20px 40px rgba(107, 114, 128, 0.1), 0 8px 25px rgba(156, 163, 175, 0.1)",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      {/* Elemento decorativo suave */}
                      <div
                        style={{
                          position: "absolute",
                          top: "-40%",
                          right: "-25%",
                          width: "150px",
                          height: "150px",
                          background:
                            "linear-gradient(45deg, rgba(229, 231, 235, 0.3), transparent)",
                          borderRadius: "50%",
                          zIndex: 1,
                        }}
                      />

                      <div
                        className="row g-3"
                        style={{ position: "relative", zIndex: 2 }}
                      >
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-person me-2"
                              style={{ color: "#d4a574" }}
                            ></i>
                            <i
                              className="bi bi-card-text me-2"
                              style={{ color: "#d4a574" }}
                            ></i>
                            Buscar por nombre o matrícula
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre o N° de matrícula"
                            value={filtroNombre}
                            onChange={(e) => setFiltroNombre(e.target.value)}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(212, 165, 116, 0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              transition: "all 0.3s ease",
                              background: "rgba(255, 255, 255, 0.8)",
                            }}
                          />
                          <small
                            style={{
                              color: "#6b7280",
                              fontSize: "0.8rem",
                              fontStyle: "italic",
                              marginTop: "4px",
                              display: "block",
                            }}
                          >
                            Ejemplo: "Juan" o "143"
                          </small>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-geo-alt me-2"
                              style={{ color: "#d4a574" }}
                            ></i>
                            Localidad
                          </label>
                          <select
                            className="form-select"
                            value={filtroLocalidad}
                            onChange={(e) => setFiltroLocalidad(e.target.value)}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(212, 165, 116, 0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255, 255, 255, 0.8)",
                            }}
                          >
                            <option value="">Todas las localidades</option>
                            {localidades.map((loc) => (
                              <option key={loc} value={loc}>
                                {loc}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-heart-pulse me-2"
                              style={{ color: "#d4a574" }}
                            ></i>
                            Obra Social
                          </label>
                          <select
                            className="form-select"
                            value={filtroObraSocial}
                            onChange={(e) =>
                              setFiltroObraSocial(e.target.value)
                            }
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(212, 165, 116, 0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255, 255, 255, 0.8)",
                            }}
                          >
                            <option value="">Todos</option>
                            <option value="si">Atiende Obra Social</option>
                            <option value="no">No atiende Obra Social</option>
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Inter', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-bookmark me-2"
                              style={{ color: "#d4a574" }}
                            ></i>
                            Especialidad
                          </label>
                          <select
                            className="form-select"
                            value={filtroEspecialidad}
                            onChange={(e) =>
                              setFiltroEspecialidad(e.target.value)
                            }
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(212, 165, 116, 0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255, 255, 255, 0.8)",
                            }}
                          >
                            <option value="">Todas las especialidades</option>
                            {especialidades.map((esp) => (
                              <option key={esp} value={esp}>
                                {esp}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tabla moderna de profesionales */}
                <div className="row">
                  <div
                    className="col-12"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    {profesionalesFiltrados.length === 0 ? (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(249, 250, 251, 0.8) 100%)",
                          backdropFilter: "blur(20px)",
                          borderRadius: "25px",
                          padding: "60px 40px",
                          border: "2px solid rgba(229, 231, 235, 0.5)",
                          boxShadow:
                            "0 20px 40px rgba(107, 114, 128, 0.1), 0 8px 25px rgba(156, 163, 175, 0.1)",
                          textAlign: "center",
                        }}
                      >
                        <i
                          className="bi bi-search"
                          style={{
                            fontSize: "3rem",
                            color: "#6b7280",
                            marginBottom: "20px",
                          }}
                        ></i>
                        <h4
                          style={{
                            color: "#374151",
                            fontFamily: "'Inter', sans-serif",
                            marginBottom: "10px",
                            textShadow: "0 2px 4px rgba(107, 114, 128, 0.1)",
                          }}
                        >
                          No se encontraron profesionales
                        </h4>
                        <p
                          style={{
                            color: "#6b7280",
                            fontSize: "1rem",
                            textShadow: "0 1px 2px rgba(255, 255, 255, 0.8)",
                          }}
                        >
                          Intenta ajustar los filtros de búsqueda
                        </p>
                      </div>
                    ) : (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(249, 250, 251, 0.8) 100%)",
                          backdropFilter: "blur(20px)",
                          borderRadius: "25px",
                          border: "2px solid rgba(229, 231, 235, 0.5)",
                          boxShadow:
                            "0 20px 40px rgba(107, 114, 128, 0.1), 0 8px 25px rgba(156, 163, 175, 0.1)",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        {/* Elemento decorativo suave */}
                        <div
                          style={{
                            position: "absolute",
                            top: "-40%",
                            right: "-25%",
                            width: "150px",
                            height: "150px",
                            background:
                              "linear-gradient(45deg, rgba(229, 231, 235, 0.3), transparent)",
                            borderRadius: "50%",
                            zIndex: 1,
                          }}
                        />

                        {/* Header de tabla para escritorio */}
                        <div
                          className="d-none d-lg-block"
                          style={{ position: "relative", zIndex: 2 }}
                        >
                          <div
                            className="professional-table-header"
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                "200px 200px 150px 120px 180px 120px 180px",
                              gap: "20px",
                              padding: "25px 30px",
                              background:
                                "linear-gradient(135deg, rgba(212, 165, 116, 0.1), rgba(212, 165, 116, 0.05))",
                              borderBottom:
                                "1px solid rgba(212, 165, 116, 0.2)",
                              fontFamily: "'Inter', sans-serif",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#374151",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <i
                                className="bi bi-person-circle me-2"
                                style={{ color: "#d4a574" }}
                              ></i>
                              Profesional
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#374151",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <i
                                className="bi bi-geo-alt me-2"
                                style={{ color: "#d4a574" }}
                              ></i>
                              Consultorio
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#374151",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-telephone me-2"
                                style={{ color: "#d4a574" }}
                              ></i>
                              Teléfono
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#374151",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-card-text me-2"
                                style={{ color: "#d4a574" }}
                              ></i>
                              Matrícula
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#374151",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <i
                                className="bi bi-bookmark me-2"
                                style={{ color: "#d4a574" }}
                              ></i>
                              Especialidades
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#374151",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-heart-pulse me-2"
                                style={{ color: "#d4a574" }}
                              ></i>
                              Obra Social
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#374151",
                                fontSize: "0.9rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="bi bi-share me-2"
                                style={{ color: "#d4a574" }}
                              ></i>
                              Redes
                            </div>
                          </div>
                        </div>

                        {/* Filas de profesionales */}
                        <div style={{ position: "relative", zIndex: 2 }}>
                          {profesionalesFiltrados.map((profesional, idx) => {
                            // Esquema de colores basado en la sección inicio - dorado y grises suaves
                            const colorSchemes = [
                              {
                                // Color dorado principal
                                primary: "#d4a574",
                                secondary: "#b8956a",
                                shadowRgba: "rgba(212, 165, 116, 0.25)",
                                hoverRgba: "rgba(212, 165, 116, 0.04)",
                              },
                              {
                                // Gris suave complementario
                                primary: "#9ca3af",
                                secondary: "#6b7280",
                                shadowRgba: "rgba(156, 163, 175, 0.25)",
                                hoverRgba: "rgba(156, 163, 175, 0.04)",
                              },
                            ];

                            const currentColorScheme =
                              colorSchemes[idx % colorSchemes.length];

                            return (
                              <React.Fragment key={profesional.nombre + idx}>
                                {/* Vista de escritorio */}
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      "200px 200px 150px 120px 180px 120px 180px",
                                    gap: "20px",
                                    padding: "20px 30px",
                                    borderBottom:
                                      idx < profesionalesFiltrados.length - 1
                                        ? "1px solid rgba(229, 231, 235, 0.6)"
                                        : "none",
                                    transition: "all 0.3s ease",
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: "0.9rem",
                                    alignItems: "center",
                                  }}
                                  className="professional-table-row d-none d-lg-grid"
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      currentColorScheme.hoverRgba;
                                    e.currentTarget.style.transform =
                                      "translateX(5px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  {/* Profesional */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "12px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "45px",
                                        height: "45px",
                                        background: `linear-gradient(135deg, ${currentColorScheme.primary}, ${currentColorScheme.secondary})`,
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: `0 4px 15px ${currentColorScheme.shadowRgba}`,
                                        flexShrink: 0,
                                      }}
                                    >
                                      <i
                                        className="fas fa-user-md"
                                        style={{
                                          fontSize: "1.1rem",
                                          color: "white",
                                        }}
                                      ></i>
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontWeight: "600",
                                          color: "#374151",
                                          fontSize: "0.95rem",
                                          marginBottom: "2px",
                                          lineHeight: "1.2",
                                          textShadow:
                                            "0 1px 2px rgba(255, 255, 255, 0.8)",
                                        }}
                                      >
                                        {profesional.nombre}
                                      </div>
                                      <div
                                        style={{
                                          color: "#6b7280",
                                          fontSize: "0.8rem",
                                          textShadow:
                                            "0 1px 2px rgba(255, 255, 255, 0.8)",
                                        }}
                                      >
                                        {profesional.localidad}
                                      </div>
                                    </div>
                                  </div>

                                  {/* Consultorio */}
                                  <div
                                    style={{
                                      color: "#6b7280",
                                      lineHeight: "1.4",
                                      display: "flex",
                                      alignItems: "center",
                                      fontSize: "0.85rem",
                                      textShadow:
                                        "0 1px 2px rgba(255, 255, 255, 0.8)",
                                    }}
                                  >
                                    {profesional.consultorio}
                                  </div>

                                  {/* Teléfono */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <a
                                      href={`tel:${profesional.telefono}`}
                                      style={{
                                        color: currentColorScheme.primary,
                                        textDecoration: "none",
                                        fontWeight: "500",
                                        transition: "color 0.2s ease",
                                        fontSize: "0.85rem",
                                        textAlign: "center",
                                      }}
                                      onMouseEnter={(e) =>
                                        (e.currentTarget.style.color =
                                          currentColorScheme.secondary)
                                      }
                                      onMouseLeave={(e) =>
                                        (e.currentTarget.style.color =
                                          currentColorScheme.primary)
                                      }
                                    >
                                      {profesional.telefono}
                                    </a>
                                  </div>

                                  {/* Matrícula */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#6b7280",
                                      fontWeight: "500",
                                      fontSize: "0.85rem",
                                      textShadow:
                                        "0 1px 2px rgba(255, 255, 255, 0.8)",
                                    }}
                                  >
                                    {profesional.matricula}
                                  </div>

                                  {/* Especialidades */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "4px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {profesional.especialidades
                                      .slice(0, 2)
                                      .map((esp) => (
                                        <span
                                          key={esp}
                                          style={{
                                            background: `linear-gradient(135deg, ${currentColorScheme.primary}15, ${currentColorScheme.secondary}15)`,
                                            color: currentColorScheme.primary,
                                            padding: "2px 8px",
                                            borderRadius: "12px",
                                            fontSize: "0.7rem",
                                            fontWeight: "500",
                                            border: `1px solid ${currentColorScheme.primary}30`,
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {esp}
                                        </span>
                                      ))}
                                    {profesional.especialidades.length > 2 && (
                                      <span
                                        style={{
                                          background:
                                            "rgba(107, 114, 128, 0.1)",
                                          color: "#6b7280",
                                          padding: "2px 6px",
                                          borderRadius: "12px",
                                          fontSize: "0.65rem",
                                          fontWeight: "500",
                                        }}
                                      >
                                        +{profesional.especialidades.length - 2}
                                      </span>
                                    )}
                                  </div>

                                  {/* Obra Social */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {profesional.atiendeObraSocial ? (
                                      <div
                                        style={{
                                          background: `linear-gradient(135deg, ${currentColorScheme.primary}15, ${currentColorScheme.secondary}15)`,
                                          color: currentColorScheme.primary,
                                          padding: "4px 12px",
                                          borderRadius: "20px",
                                          fontSize: "0.75rem",
                                          fontWeight: "600",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "4px",
                                          border: `1px solid ${currentColorScheme.primary}30`,
                                        }}
                                      >
                                        <i className="bi bi-check-circle-fill"></i>
                                        Sí
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          background:
                                            "rgba(107, 114, 128, 0.1)",
                                          color: "#6b7280",
                                          padding: "4px 12px",
                                          borderRadius: "20px",
                                          fontSize: "0.75rem",
                                          fontWeight: "500",
                                        }}
                                      >
                                        No
                                      </div>
                                    )}
                                  </div>

                                  {/* Redes sociales */}
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {profesional.redes.twitter && (
                                      <a
                                        href={profesional.redes.twitter}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "28px",
                                          height: "28px",
                                          borderRadius: "50%",
                                          background:
                                            "linear-gradient(135deg, #1da1f2, #0d8bd9)",
                                          color: "white",
                                          textDecoration: "none",
                                          transition: "transform 0.2s ease",
                                          boxShadow:
                                            "0 2px 8px rgba(29, 161, 242, 0.3)",
                                        }}
                                      >
                                        <i
                                          className="bi bi-twitter-x"
                                          style={{ fontSize: "0.8rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {profesional.redes.facebook && (
                                      <a
                                        href={profesional.redes.facebook}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "28px",
                                          height: "28px",
                                          borderRadius: "50%",
                                          background:
                                            "linear-gradient(135deg, #3b5998, #2d4373)",
                                          color: "white",
                                          textDecoration: "none",
                                          transition: "transform 0.2s ease",
                                          boxShadow:
                                            "0 2px 8px rgba(59, 89, 152, 0.3)",
                                        }}
                                      >
                                        <i
                                          className="bi bi-facebook"
                                          style={{ fontSize: "0.8rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {profesional.redes.instagram && (
                                      <a
                                        href={profesional.redes.instagram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "28px",
                                          height: "28px",
                                          borderRadius: "50%",
                                          background:
                                            "linear-gradient(135deg, #e4405f, #c13584)",
                                          color: "white",
                                          textDecoration: "none",
                                          transition: "transform 0.2s ease",
                                          boxShadow:
                                            "0 2px 8px rgba(228, 64, 95, 0.3)",
                                        }}
                                      >
                                        <i
                                          className="bi bi-instagram"
                                          style={{ fontSize: "0.8rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {profesional.redes.linkedin && (
                                      <a
                                        href={profesional.redes.linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "28px",
                                          height: "28px",
                                          borderRadius: "50%",
                                          background:
                                            "linear-gradient(135deg, #0077b5, #005885)",
                                          color: "white",
                                          textDecoration: "none",
                                          transition: "transform 0.2s ease",
                                          boxShadow:
                                            "0 2px 8px rgba(0, 119, 181, 0.3)",
                                        }}
                                      >
                                        <i
                                          className="bi bi-linkedin"
                                          style={{ fontSize: "0.8rem" }}
                                        ></i>
                                      </a>
                                    )}
                                  </div>
                                </div>

                                {/* Vista móvil - Cards compactas */}
                                <div
                                  className="d-lg-none"
                                  style={{
                                    padding: "20px",
                                    borderBottom:
                                      idx < profesionalesFiltrados.length - 1
                                        ? "1px solid rgba(226, 232, 240, 0.6)"
                                        : "none",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        background: `linear-gradient(135deg, ${currentColorScheme.primary}, ${currentColorScheme.secondary})`,
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: `0 4px 15px ${currentColorScheme.shadowRgba}`,
                                        flexShrink: 0,
                                      }}
                                    >
                                      <i
                                        className="fas fa-user-md"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "white",
                                        }}
                                      ></i>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                      <h5
                                        style={{
                                          fontWeight: "600",
                                          color: "#1e293b",
                                          margin: "0 0 5px 0",
                                          fontFamily: "'Poppins', sans-serif",
                                          fontSize: "1.1rem",
                                        }}
                                      >
                                        {profesional.nombre}
                                      </h5>
                                      <div
                                        style={{
                                          color: "#64748b",
                                          fontSize: "0.85rem",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <i
                                          className="bi bi-geo-alt-fill me-1"
                                          style={{ color: "#2f3c68" }}
                                        ></i>
                                        {profesional.consultorio}
                                      </div>
                                      <div
                                        style={{
                                          color: "#64748b",
                                          fontSize: "0.85rem",
                                        }}
                                      >
                                        <i
                                          className="bi bi-telephone-fill me-1"
                                          style={{
                                            color: currentColorScheme.secondary,
                                          }}
                                        ></i>
                                        <a
                                          href={`tel:${profesional.telefono}`}
                                          style={{
                                            color: currentColorScheme.secondary,
                                            textDecoration: "none",
                                          }}
                                        >
                                          {profesional.telefono}
                                        </a>
                                        <span className="ms-3">
                                          <i
                                            className="bi bi-card-text me-1"
                                            style={{
                                              color: currentColorScheme.primary,
                                            }}
                                          ></i>
                                          Mat. {profesional.matricula}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Especialidades móvil */}
                                  <div style={{ marginBottom: "12px" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "5px",
                                      }}
                                    >
                                      {profesional.especialidades.map((esp) => (
                                        <span
                                          key={esp}
                                          style={{
                                            background: `linear-gradient(135deg, ${currentColorScheme.primary}15, ${currentColorScheme.secondary}15)`,
                                            color: currentColorScheme.primary,
                                            padding: "3px 10px",
                                            borderRadius: "12px",
                                            fontSize: "0.75rem",
                                            fontWeight: "500",
                                            border: `1px solid ${currentColorScheme.primary}30`,
                                          }}
                                        >
                                          {esp}
                                        </span>
                                      ))}
                                    </div>
                                  </div>

                                  {/* Footer móvil */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      paddingTop: "12px",
                                      borderTop:
                                        "1px solid rgba(226, 232, 240, 0.6)",
                                    }}
                                  >
                                    <div>
                                      {profesional.atiendeObraSocial ? (
                                        <div
                                          style={{
                                            background:
                                              "linear-gradient(135deg, rgba(34, 197, 94, 0.1), rgba(16, 185, 129, 0.1))",
                                            color: "#10b981",
                                            padding: "4px 10px",
                                            borderRadius: "15px",
                                            fontSize: "0.7rem",
                                            fontWeight: "600",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "3px",
                                            border:
                                              "1px solid rgba(34, 197, 94, 0.2)",
                                          }}
                                        >
                                          <i className="bi bi-check-circle-fill"></i>
                                          Obra Social
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            background:
                                              "rgba(148, 163, 184, 0.1)",
                                            color: "#94a3b8",
                                            padding: "4px 10px",
                                            borderRadius: "15px",
                                            fontSize: "0.7rem",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Sin Obra Social
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                      }}
                                    >
                                      {profesional.redes.twitter && (
                                        <a
                                          href={profesional.redes.twitter}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            background:
                                              "linear-gradient(135deg, #1da1f2, #0d8bd9)",
                                            color: "white",
                                            textDecoration: "none",
                                          }}
                                        >
                                          <i
                                            className="bi bi-twitter-x"
                                            style={{ fontSize: "0.9rem" }}
                                          ></i>
                                        </a>
                                      )}
                                      {profesional.redes.facebook && (
                                        <a
                                          href={profesional.redes.facebook}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            background:
                                              "linear-gradient(135deg, #3b5998, #2d4373)",
                                            color: "white",
                                            textDecoration: "none",
                                          }}
                                        >
                                          <i
                                            className="bi bi-facebook"
                                            style={{ fontSize: "0.9rem" }}
                                          ></i>
                                        </a>
                                      )}
                                      {profesional.redes.instagram && (
                                        <a
                                          href={profesional.redes.instagram}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            background:
                                              "linear-gradient(135deg, #e4405f, #c13584)",
                                            color: "white",
                                            textDecoration: "none",
                                          }}
                                        >
                                          <i
                                            className="bi bi-instagram"
                                            style={{ fontSize: "0.9rem" }}
                                          ></i>
                                        </a>
                                      )}
                                      {profesional.redes.linkedin && (
                                        <a
                                          href={profesional.redes.linkedin}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            background:
                                              "linear-gradient(135deg, #0077b5, #005885)",
                                            color: "white",
                                            textDecoration: "none",
                                          }}
                                        >
                                          <i
                                            className="bi bi-linkedin"
                                            style={{ fontSize: "0.9rem" }}
                                          ></i>
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Estilos CSS */}
              <style>{`
                              .form-control:focus, .form-select:focus {
                                border-color: #d4a574 !important;
                                box-shadow: 0 0 0 0.2rem rgba(212, 165, 116, 0.25) !important;
                                outline: none;
                              }
                              
                              .professional-table-row:hover .bi {
                                transform: scale(1.1);
                              }
                              
                              /* Efecto hover suave para las redes sociales */
                              .professional-table-row a[href*="twitter"]:hover,
                              .professional-table-row a[href*="facebook"]:hover,
                              .professional-table-row a[href*="instagram"]:hover,
                              .professional-table-row a[href*="linkedin"]:hover {
                                transform: scale(1.1) !important;
                                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
                              }
                              
                              @media (max-width: 768px) {
                                .professionals.section {
                                  padding: 40px 0 !important;
                                }
                                
                                .professionals h2 {
                                  font-size: 2.2rem !important;
                                }
                                
                                .professionals .col-12 > div {
                                  padding: 25px 20px !important;
                                }
                              }
                              
                              @media (max-width: 480px) {
                                .professionals.section {
                                  padding: 30px 0 !important;
                                }
                                
                                .professionals h2 {
                                  font-size: 1.8rem !important;
                                }
                                
                                .professionals .col-12 > div {
                                  padding: 20px 15px !important;
                                }
                              }
                            `}</style>
            </section>
          </div>
        )}
      </main>

      {/* FOOTER - igual que el original */}
      <footer id="footer" className="footer">
        <div className="container">
          <div className="copyright text-center">
            <p>
              © <span>Copyright</span>{" "}
              <strong className="px-1 sitename">COFOLP</strong>{" "}
              <span>All Rights Reserved</span>
            </p>
          </div>
          <div className="credits">
            Designed by <a href="#">COFOLP</a>
          </div>
        </div>
      </footer>

      <a
        href="#"
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
    </>
  );
};
